import Axios from "@/plugins/Axios";
import Disciplina from "@/Models/Disciplina";
import store from "@/store";

export class DisciplinasService {
  async atualizarDisciplina(disciplina) {
    if (!disciplina?.id) throw new Error("Discipline ID is required for update");

    const response = await Axios().put(`disciplinas/${disciplina.id}`, disciplina);
    return response.data;
  }

  async criarDisciplina(disciplina) {
    if (!disciplina) {
      throw new Error("Discipline data is required");
    }

    const response = await Axios().post("disciplinas", disciplina);
    return response.data;
  }

  async deletarDisciplina(disciplina) {
    if (!disciplina?.id) throw new Error("Discipline ID is required for deletion");

    const response = await Axios().delete(`disciplinas/${disciplina.id}`);
    return response.data;
  }

  async listarAreasDeConhecimento() {
    const response = await Axios().get("disciplinas/area-conhecimento");
    return response.data;
  }

  async listarDisciplinas(gestaoId) {
    if (!gestaoId) throw new Error("Management ID is required");

    const response = await Axios().get(`disciplinas/listar/${gestaoId}`);
    return response.data.map((disciplina) => new Disciplina(disciplina));
  }

  async listarDisciplinasAEE() {
    const response = await Axios().get("disciplinas/educacao-inclusiva");
    return response.data.map((disciplina) => new Disciplina(disciplina));
  }

  async listarDisciplinasPorTurma(turmaId) {
    if (!turmaId) throw new Error("Class ID is required");

    const response = await Axios().get(`disciplinas/turma/${turmaId}`);
    return response.data.map((disciplina) => new Disciplina(disciplina));
  }

  async recuperarDisciplina(disciplina) {
    if (!disciplina?.id) throw new Error("Discipline ID is required for recovery");

    return this.atualizarDisciplina({ ...disciplina, deleted_at: null });
  }

  async syncAll() {
    const response = await Axios().get("disciplinas");
    return response.data.map((disciplina) => new Disciplina(disciplina));
  }

  async syncAllPaginated(pageNumber, query) {
    const params = new URLSearchParams();

    if (pageNumber !== undefined && pageNumber !== null) {
      params.append("page", pageNumber);
    }
    if (query) {
      params.append("query", query);
    }

    const response = await Axios().get(`disciplinas/paginate?${params.toString()}`);
    return response.data;
  }
}

export default new DisciplinasService();
